export enum EKWGeneratorTableTabs {
    relatedKeywords = "relatedKeywords",
    phraseMatch = "phraseMatch",
    trending = "trending",
    questions = "questions",
}

export const tabsIndexMap = {
    [EKWGeneratorTableTabs.phraseMatch]: 0,
    [EKWGeneratorTableTabs.relatedKeywords]: 1,
    [EKWGeneratorTableTabs.trending]: 2,
    [EKWGeneratorTableTabs.questions]: 3,
};

interface IKeywordDataRecord {
    averageVolume: number;
    clicks: number;
    cpc: number;
    cpcHighBid: number;
    cpcLowBid: number;
    difficulty: number;
    favicon: string;
    keyword: string;
    latestZeroClicks: number;
    leadingSite: string;
    prevVolume: number;
    primaryIntent: string;
    secondaryIntent: string;
    volumeChange: number;
    volumeChangePresentation: string;
    volumeChangeState: string;
    volumeTrend: Record<string, number>;
    windowVolume?: number;
    monthlyVolume?: number;
    volume?: number;
    paidShare?: number;
    organicShare?: number;
}

export interface IGoogleKeywordGeneratorApiResponse {
    records: IKeywordDataRecord[];
    totalClicks: number;
    totalVolume: number;
    totalRecords: number;
}

interface IRelatedKeywordDataRecord extends IKeywordDataRecord {
    score: number;
}

export interface IRelatedKeywordsApiResponse extends IGoogleKeywordGeneratorApiResponse {
    records: IRelatedKeywordDataRecord[];
    maxScore: number;
}

export interface IRecommendation {
    keyword: string;
    cpc: string;
    volume: string;
}
